import React, { useEffect, useState } from 'react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

export default function AutoCompleteAddress2({
    formik = {},
    address,
    setAddress,
    location,
    setlocation,
}) {
    return (
        <LocationInput
            formik={formik}
            address={address}
            setAddress={setAddress}
            location={location}
            setlocation={setlocation}
        />
    )
}

function LocationInput({ address, formik, setAddress, location, setlocation }: any) {

    // Input style to match your other form fields
    const inputStyle = {
        width: '100%',
        padding: '8px',
        border: '1px solid #000',
        fontSize: '12px',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: 'white',
        color: 'black'
    }

    const handleChangeAddress = (newAddress) => {
        setAddress(newAddress)
    }

    const handleSelectAddress = (newAddress) => {
        setAddress(newAddress)
        geocodeByAddress(newAddress)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => {
                if (Object.keys(formik).length > 0) {
                    formik?.setFieldValue('longitute', parseFloat(latLng.lng))
                    setTimeout(() => {
                        formik?.setFieldValue('latitute', parseFloat(latLng.lat))
                    }, 500)
                }
                setlocation(latLng)
            })
            .catch((error) => console.error('Error', error))
    }

    return (
        <PlacesAutocomplete
            value={address}
            onChange={handleChangeAddress}
            onSelect={handleSelectAddress}
        >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div style={{ position: 'relative' }}>
                    <input
                        {...getInputProps({
                            placeholder: 'Search Places ...',
                            style: inputStyle
                        })}
                    />
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        backgroundColor: 'white',
                        border: suggestions.length > 0 ? '1px solid #000' : 'none',
                        borderTop: 'none',
                        maxHeight: '200px',
                        overflowY: 'auto'
                    }}>
                        {loading && (
                            <div style={{
                                padding: '8px',
                                fontSize: '12px',
                                fontFamily: 'Arial, sans-serif',
                                color: '#666'
                            }}>
                                Loading...
                            </div>
                        )}
                        {suggestions.map((suggestion) => {
                            const style = suggestion.active
                                ? {
                                    backgroundColor: '#f0f0f0',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    fontSize: '12px',
                                    fontFamily: 'Arial, sans-serif',
                                    borderBottom: '1px solid #eee'
                                }
                                : {
                                    backgroundColor: '#ffffff',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    fontSize: '12px',
                                    fontFamily: 'Arial, sans-serif',
                                    borderBottom: '1px solid #eee'
                                }
                            return (
                                <div
                                    key={suggestion.placeId}
                                    {...getSuggestionItemProps(suggestion, {
                                        style,
                                    })}
                                >
                                    <span>{suggestion.description}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
        </PlacesAutocomplete>
    )
}